import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React ,{useState} from "react";
import { useAddTeacherQuestionMutation,useGetCourseListQuery} from "../../../Services/api";

export default function Create() {
    const notify = () => '';
    const { register, handleSubmit, formState: { errors }} = useForm();
    const [addTeacherQuestion,isLoading] = useAddTeacherQuestionMutation();
    const onSubmit = (values,e) => {
        const formData = new FormData();
        formData.append('title', values.title);
        formData.append('descriptions', values.descriptions);
        formData.append('start_date', values.start_date);
        formData.append('end_date',values.end_date);
        formData.append('first_post_date',values.first_post_date);
        formData.append('course_task_id',values.course_task_id);
        addTeacherQuestion( formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                 e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    const [courseCode,setCourseCode] = useState(0);
    const findLession=(e)=>{
        setCourseCode(e.target.value);
    }
   
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Question Details</h5>
                        <form onSubmit={handleSubmit(onSubmit)} >
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Task</label>
                                <div className="col-sm-10">
                                <select  {...register("course_task_id", { required: true })} className="form-control" onChange={findLession}>
                                    <option value="">Select Task</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.course_task_id && <span  className="text-danger">course task is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Title</label>
                                <div className="col-sm-10">
                                    <input type="title" {...register("title" ,{ required: true})} className="form-control" />
                                    {errors.title && <span  className="text-danger">Title is required</span>}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Start Date</label>
                                <div className="col-sm-10">
                                    <input type="date" {...register("start_date" ,{ required: true})} className="form-control" />
                                    {errors.start_date && <span  className="text-danger">Start Date is required</span>}
                                </div>
                            </div>
                             <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">End Date</label>
                                <div className="col-sm-10">
                                    <input type="date" {...register("end_date" ,{ required: true})} className="form-control" />
                                    {errors.end_date && <span  className="text-danger">End Date is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">First Post Date</label>
                                <div className="col-sm-10">
                                    <input type="date" {...register("first_post_date" ,{ required: true})} className="form-control" />
                                    {errors.first_post_date && <span  className="text-danger">First post date is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Descriptions</label>
                                <div className="col-sm-10">
                                    <textarea {...register("descriptions" ,{ required: true})} className="form-control" rows={7}></textarea>
                                    {errors.descriptions && <span  className="text-danger">Descriptions is required</span>}
                                </div>
                            </div>
                          <div className="modal-footer">
                                
                                {isLoading.status !='pending' ? 
                                 <>
                                    <button type="submit" className="btn btn-warning">Save changes</button>
                                 </>     
                                :
                                <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div> 
                        
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}